import React, { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { error as ErrorToast } from "@react/react-spectrum/Toast";
import CamSlidingPane from "../../Common/CamSlidingPane/CamSlidingPane";
import { HMSSourceSystemAccountsLabel } from "../../../constants/SlidingPaneLabels";
import AccountMappingForm from "../../Forms/AccountMappingForm/AccountMappingForm";
import LoadingDialog from "../LoadingDialog";
import { goldenRecordApi } from "../../../api/goldenRecordApi";

export default function GetSourceSystemDetailsDialog({
  onClose,
  accountId,
  isCalled,
  open,
}) {
  const [nodeValue, setNodeValue] = useState({});
  const { authState } = useOktaAuth();
  const [isLoadingDialog, setLoadingDialog] = useState(false);

  useEffect(() => {
    if (isCalled && accountId !== undefined) {
      setLoadingDialog(true);
      goldenRecordApi
        .fetchGoldenRecordDetails(
          { account_id: accountId },
          authState.accessToken
        )
        .then((data) => {
          setLoadingDialog(false);
          const flattenedData = data.source_system_accounts.find(
            (acc) => acc.account_id === accountId
          );
          flattenedData.street = flattenedData.address.street;
          flattenedData.city = flattenedData.address.city;
          flattenedData.state = flattenedData.address.state;
          flattenedData.country = flattenedData.address.country;
          flattenedData.postalcode = flattenedData.address.postalcode;
          setNodeValue({ ...data, ...flattenedData });
        })
        .catch((error) => {
          setLoadingDialog(false);
          console.log(error);
          ErrorToast("Error fetching account details", {
            timeout: 5000,
          });
          setNodeValue([]);
        });
    }
  }, [accountId, isCalled]);

  return (
    <>
      <LoadingDialog isOpen={isLoadingDialog} />
      {open && (
        <CamSlidingPane
          isPaneOpenFlag={open}
          handleOpenDialog={onClose}
          paneTitle="Details"
          Component={
            <AccountMappingForm
              data={nodeValue}
              labels={HMSSourceSystemAccountsLabel(nodeValue)}
            />
          }
        />
      )}
    </>
  );
}

GetSourceSystemDetailsDialog.defaultProps = {
  accountId: "",
};

GetSourceSystemDetailsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isCalled: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
};
